export enum HomeTestIds {
  GallerySection = 'gallery_sec',
  ItemsSection = 'items_sec',
  StoresSection = 'stores_sec',
}
